import React from 'react'
import PropTypes from 'prop-types'

const HelpDetails = ({ pharmacy, category, telephone }) => {
  return (
    <>
      <section className="p-2 mb-4 border">
        {category === 'McColls' ? (
          <>
            <p className="font-semibold text-secondary">
              Telephone this store:
            </p>
            <a href={`tel:${telephone}`}>{telephone}</a>
            <p className="font-semibold text-secondary">
              For Morrisons Daily assistance or feedback
            </p>
            <a href="https://www.morrisons.com/help/morrisons-daily/">
              Visit our Help Hub
            </a>
          </>
        ) : (
          <>
            <p className="font-semibold text-secondary">
              For Store assistance or feedback
            </p>
            <a href="https://www.morrisons.com/help/in-store-experience/">
              Visit our Help Hub
            </a>
            <p className="mt-2 font-semibold text-secondary">
              For Doorstep Deliveries call
            </p>
            <a href="tel:0345 6116111">0345 6116111 option 5</a>

            <p className="mt-2 font-semibold text-secondary">
              For Cafe Takeaway
            </p>
            <a
              href="https://my.morrisons.com/morrisons-cafe/"
              target="_blank"
              rel="noreferrer"
            >
              Click Here
            </a>
            {pharmacy && (
              <>
                <p className="mt-2 font-semibold text-secondary">Pharmacy</p>
                <a href={`tel:${pharmacy}`}>{pharmacy}</a>
              </>
            )}
          </>
        )}
      </section>
    </>
  )
}
HelpDetails.propTypes = {
  pharmacy: PropTypes.string,
  category: PropTypes.string,
  telephone: PropTypes.string,
}

export default HelpDetails
